import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmReasonCanceled } from '../interfaces/IKnmReasonCanceled';

export async function knmReasonsCanceledApi(): Promise<IKnmReasonCanceled[]> {
  return apiGet<IKnmReasonCanceled[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/abrogation-reasons`);
}

export async function createKnmReasonCanceled(reason: Omit<IKnmReasonCanceled, 'id'>): Promise<void> {
  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/abrogation-reasons`,
    body: reason,
  });
}

export async function updateKnmReasonsCanceled(reason: IKnmReasonCanceled): Promise<void> {
  const { id, ...data } = reason;

  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/abrogation-reasons/${id}`, data);
}
